import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { BaseService } from '../loja/base.service';

@Injectable()
export class TrailHomeService extends BaseService {

  constructor(protected http: Http) {
    super(http, 'api/v2/client', 'trilha/geral/web')
  }

}


// WEBPACK FOOTER //
// ./src/app/services/home-smart/trails-home.service.ts